import React from 'react'
import * as S from './style';
import { ProfileImage, Label } from 'components';

import FieldPhotoImageSample from 'assets/img/profile/img_field_photo_example.png';

export default function FieldPhotoPopupContents() {
  return (
    <S.ContentsContainer>
      <S.ProfileExampleWrapper>
        <ProfileImage size={'XL'} background={FieldPhotoImageSample} />
      </S.ProfileExampleWrapper>
      <S.ProfileGuideWrapper>
        위의 예시를 참고하시어 활동 사진을 등록해주세요.
      </S.ProfileGuideWrapper>
      <S.ProfileGuideWrapper>
        아래 항목에 해당 될 경우에는 승인 되지 않습니다.
      </S.ProfileGuideWrapper>
      <S.InformationList margin={'0px 0px 8px 0px'}>
        <S.InformationItem>
          로고 사진
        </S.InformationItem>
        <S.InformationItem>
          업체 광고 및 연락처 노출
        </S.InformationItem>
      </S.InformationList>
      <S.LabelContainer>
        <Label
          fontStyle={'body2'}
          color={'gray_opacity_800'}
          contents={
            '고객님이 보시는 파트너 소개 페이지 상단에 노출됩니다. 멋진 활동 사진을 통해 고객님의 선호도를 높여보세요. '
          }
        />
      </S.LabelContainer>
    </S.ContentsContainer>
  );
}
